(() => {
  const updateHeader = () => document.body.classList.toggle('poizn-scrolled', window.scrollY > 80);
  document.addEventListener('DOMContentLoaded', updateHeader, { once: true });
  window.addEventListener('scroll', updateHeader, { passive: true });

  const setupEditorialMotion = () => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const hero = document.querySelector('.poizn-home__hero');
    const slides = [...document.querySelectorAll('[data-poizn-hero-slide]')];
    const counter = document.querySelector('[data-poizn-hero-count]');
    if (hero && slides.length > 1) {
      let active = 0;
      let timer;
      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === active);
          slide.setAttribute('aria-hidden', String(i !== active));
        });
        if (counter) counter.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (!reducedMotion.matches && !document.hidden) timer = window.setInterval(() => show(active + 1), 3000);
      };
      hero.querySelector('[data-poizn-hero-prev]')?.addEventListener('click', () => { show(active - 1); start(); });
      hero.querySelector('[data-poizn-hero-next]')?.addEventListener('click', () => { show(active + 1); start(); });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', start);
      reducedMotion.addEventListener('change', start);
      start();
    }

    const rail = document.querySelector('[data-poizn-product-rail]');
    if (rail && rail.children.length > 1) {
      let timer;
      const step = () => rail.children[0]?.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0);
      const move = (direction) => {
        const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - step() / 2;
        const atStart = rail.scrollLeft <= step() / 2;
        rail.scrollTo({ left: direction > 0 && atEnd ? 0 : direction < 0 && atStart ? rail.scrollWidth : rail.scrollLeft + step() * direction, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (!reducedMotion.matches && !document.hidden && rail.scrollWidth > rail.clientWidth) timer = window.setInterval(() => move(1), 4200);
      };
      document.querySelector('[data-poizn-rail-prev]')?.addEventListener('click', () => { move(-1); start(); });
      document.querySelector('[data-poizn-rail-next]')?.addEventListener('click', () => { move(1); start(); });
      rail.addEventListener('mouseenter', stop);
      rail.addEventListener('mouseleave', start);
      rail.addEventListener('focusin', stop);
      rail.addEventListener('focusout', start);
      rail.addEventListener('touchstart', stop, { passive: true });
      rail.addEventListener('touchend', start, { passive: true });
      document.addEventListener('visibilitychange', start);
      reducedMotion.addEventListener('change', start);
      start();
    }

    document.querySelectorAll('.poizn-product-gallery').forEach((gallery) => {
      const carousel = gallery.querySelector('.product-gallery__carousel');
      if (!carousel) return;
      let timer;
      const visible = () => [...carousel.querySelectorAll('.product-gallery__media:not([hidden])')];
      const move = (direction) => {
        const items = visible();
        if (items.length < 2) return;
        const offsets = items.map((item) => item.offsetLeft - items[0].offsetLeft);
        const pageSize = window.matchMedia('(min-width: 1000px)').matches ? 2 : 1;
        const lastStart = Math.max(0, items.length - pageSize);
        const starts = [];
        for (let index = 0; index < items.length; index += pageSize) {
          const startIndex = Math.min(index, lastStart);
          if (!starts.includes(startIndex)) starts.push(startIndex);
        }
        const current = starts.reduce((best, startIndex, pageIndex) => Math.abs(offsets[startIndex] - carousel.scrollLeft) < Math.abs(offsets[starts[best]] - carousel.scrollLeft) ? pageIndex : best, 0);
        const next = (current + direction + starts.length) % starts.length;
        carousel.scrollTo({ left: offsets[starts[next]], behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (reducedMotion.matches || document.hidden || visible().length < 3) return;
        timer = window.setInterval(() => {
          const currentMedia = visible().find((item) => Math.abs(item.offsetLeft - visible()[0].offsetLeft - carousel.scrollLeft) < 20);
          if (currentMedia?.dataset.mediaType === 'image') move(1);
        }, 5000);
      };
      gallery.querySelector('[data-poizn-gallery-prev]')?.addEventListener('click', () => { move(-1); start(); });
      gallery.querySelector('[data-poizn-gallery-next]')?.addEventListener('click', () => { move(1); start(); });
      gallery.addEventListener('mouseenter', stop);
      gallery.addEventListener('mouseleave', start);
      gallery.addEventListener('focusin', stop);
      gallery.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', start);
      reducedMotion.addEventListener('change', start);
      start();
    });

    document.querySelectorAll('[data-poizn-lookbook]').forEach((lookbook) => {
      const looks = [...lookbook.querySelectorAll('[data-poizn-look]')];
      const links = [...lookbook.querySelectorAll('[data-poizn-lookbook-page]')];
      if (links.length < 2) return;
      const showPage = (page, updateUrl = false) => {
        const current = Math.max(1, Math.min(links.length, page));
        looks.forEach((look, index) => { look.hidden = Math.floor(index / 8) + 1 !== current; });
        links.forEach((link) => {
          if (Number(link.dataset.poiznLookbookPage) === current) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (current === 1) url.searchParams.delete('lookbook_page');
          else url.searchParams.set('lookbook_page', String(current));
          window.history.pushState({}, '', url);
          lookbook.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        }
      };
      const fromUrl = () => Number(new URLSearchParams(window.location.search).get('lookbook_page')) || 1;
      links.forEach((link) => link.addEventListener('click', (event) => {
        event.preventDefault();
        showPage(Number(link.dataset.poiznLookbookPage), true);
      }));
      window.addEventListener('popstate', () => showPage(fromUrl()));
      showPage(fromUrl());
    });
  };
  document.addEventListener('DOMContentLoaded', setupEditorialMotion, { once: true });
})();
